export default __webpack_public_path__ + "static/media/go-workflow-library.6d142bb5.png";